var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 2.43262C1.66699 2.0098 2.00976 1.66699 2.43262 1.66699H13.1514C13.5742 1.66699 13.917 2.0098 13.917 2.43262V3.92799C13.9082 3.74447 13.8338 3.56351 13.6936 3.42333C13.3946 3.12435 12.9098 3.12435 12.6109 3.42333L7.02723 9.00701L4.5061 6.48583C4.20712 6.18685 3.72234 6.18685 3.42337 6.48583C3.12434 6.7849 3.12434 7.26959 3.42337 7.56866L6.48587 10.6312C6.78484 10.9301 7.26962 10.9301 7.5686 10.6312L13.6936 4.50616C13.8338 4.36598 13.9082 4.18502 13.917 4.00151V13.1514C13.917 13.5742 13.5742 13.917 13.1514 13.917H2.43262C2.00976 13.917 1.66699 13.5742 1.66699 13.1514V2.43262Z",
    fill: "#7F869A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5V15.3333C15.8333 15.6095 15.6095 15.8333 15.3333 15.8333H5",
    stroke: "#7F869A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 6.66699V17.8337C18.3337 18.1098 18.1098 18.3337 17.8337 18.3337H6.66699",
    stroke: "#7F869A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/selectAll.f9856516d2830557980e5e3fe99ce55e.svg";
export { ForwardRef as ReactComponent };